(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offer-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const timers = document.querySelectorAll("[data-countdown]");
  timers.forEach(countdown => {
    const target = new Date(countdown.getAttribute("data-countdown")).getTime();

    setInterval(() => {
      const now = new Date().getTime();
      const diff = target - now;

      if (diff > 0) {
        countdown.querySelector(".days").textContent = Math.floor(diff / (1000*60*60*24));
        countdown.querySelector(".hours").textContent = Math.floor((diff % (1000*60*60*24)) / (1000*60*60));
        countdown.querySelector(".minutes").textContent = Math.floor((diff % (1000*60*60)) / (1000*60));
        countdown.querySelector(".seconds").textContent = Math.floor((diff % (1000*60)) / 1000);
      }
    }, 1000);
  });
});

  } catch(e) { console.error(e); }
})();
})();
